// removed by extract-text-webpack-plugin
module.exports = {"detail":"var__detail___Xyz0-A","content":"var__content___1I3wMG","fileDetail":"var__fileDetail___3OjyAS"};